import { SLICE_NAME } from "../../model/types/types";

export const ActionType = {
  TOGGLE_SIDE_BLOCK: `${SLICE_NAME}/toggle_side_block`,
  SAVE_BUTTON_CLICKED: `${SLICE_NAME}/save_button_clicked`,
  CREATE_BUTTON_CLICKED: `${SLICE_NAME}/create_button_clicked`,
} as const;
